let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("48ML3"), load("aZinD"), load("7rEYM"), load("ffEVr"), load("joJy8"), load("aHE9G"), load("e2946")]).then(() => parcelRequire('jupik'));